module.exports = __webpack_public_path__ + "assets/img/btn-view-all-0192e5db.png";